<!-- Copyright (c) 2023, Alix Mougenot (Au pied des Arbres), alix.mougenot@gmail.com -->
<!-- See license file. -->
<script setup lang="ts">
import type { EventType, EventDirection } from "@/types";
const props = defineProps<{ type: EventType; direction: EventDirection }>();
</script>

<template>
  <svg
    v-if="props.type == 'Email'"
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="512"
    height="512"
    fill="rgba(109, 32, 119, 1)"
  >
    <path
      d="M12,0a12,12,0,1,0,7.092,21.681l-1.775-2.419A9,9,0,1,1,21,12v1.5a1.5,1.5,0,0,1-3,0V12a6.023,6.023,0,1,0-1.922,4.388A4.48,4.48,0,0,0,24,13.5V12A12.013,12.013,0,0,0,12,0Zm0,15a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"
    />
  </svg>
  <svg
    v-else-if="
      props.type == 'Appel Téléphonique' && props.direction == 'Sortant'
    "
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="512"
    height="512"
    fill="rgba(109, 32, 119, 1)"
  >
    <path
      d="M23.98,2.023v4a1,1,0,0,1-2,0V3.46l-5.3,5.272a1,1,0,0,1-1.41-1.418L20.59,2.023H17.98a1,1,0,0,1,0-2h4A2,2,0,0,1,23.98,2.023Zm-.905,14.739a3.1,3.1,0,0,1,0,4.378l-.912,1.05c-8.191,7.838-28.12-12.085-20.4-20.3l1.149-1A3.085,3.085,0,0,1,7.241.928c.03.031,1.883,2.439,1.883,2.439a3.1,3.1,0,0,1-.006,4.281L7.959,9.105A12.781,12.781,0,0,0,14.89,16.05l1.465-1.165a3.1,3.1,0,0,1,4.28-.006S23.044,16.732,23.075,16.762ZM21.7,18.216s-2.393-1.842-2.424-1.872a1.1,1.1,0,0,0-1.549,0c-.027.026-2.044,1.634-2.044,1.634a1,1,0,0,1-.979.152A15,15,0,0,1,5.88,9.318a1,1,0,0,1,.145-.995S7.632,6.306,7.659,6.279a1.1,1.1,0,0,0,0-1.549C7.629,4.7,5.787,2.306,5.787,2.306a1.1,1.1,0,0,0-1.51.038l-1.149,1C-2.516,10.126,14.757,26.442,20.7,20.826l.912-1.05A1.12,1.12,0,0,0,21.7,18.216Z"
    />
  </svg>
  <svg
    v-else-if="
      props.type == 'Appel Téléphonique' && props.direction == 'Entrant'
    "
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="512"
    height="512"
    fill="rgba(109, 32, 119, 1)"
  >
    <path
      d="M14.98,7.023v-4a1,1,0,0,1,2,0V5.634C17.61,5,21.681.908,22.273.316A1,1,0,1,1,23.687,1.73c-.592.592-4.642,4.665-5.268,5.293H20.98a1,1,0,0,1,0,2h-4A2,2,0,0,1,14.98,7.023Zm8.095,9.739a3.1,3.1,0,0,1,0,4.378l-.912,1.05c-8.191,7.838-28.119-12.084-20.4-20.3l1.15-1A3.081,3.081,0,0,1,7.24.929c.031.03,1.883,2.438,1.883,2.438a3.109,3.109,0,0,1-.006,4.282L7.959,9.105A12.784,12.784,0,0,0,14.89,16.05l1.465-1.165a3.1,3.1,0,0,1,4.28-.006S23.044,16.732,23.075,16.762ZM21.7,18.216s-2.393-1.842-2.424-1.872a1.1,1.1,0,0,0-1.549,0c-.027.026-2.044,1.634-2.044,1.634a1,1,0,0,1-.979.152A15.009,15.009,0,0,1,5.879,9.319a1,1,0,0,1,.145-1S7.632,6.305,7.659,6.279a1.1,1.1,0,0,0,0-1.549c-.03-.03-1.872-2.425-1.872-2.425a1.1,1.1,0,0,0-1.51.039l-1.15,1C-2.515,10.127,14.757,26.441,20.7,20.827l.912-1.051A1.12,1.12,0,0,0,21.7,18.216Z"
    />
  </svg>
  <svg
    v-else-if="props.type == 'Message sur Répondeur'"
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="512"
    height="512"
    fill="rgba(109, 32, 119, 1)"
  >
    <path
      d="M3,7V3A2,2,0,0,1,5,1H9A1,1,0,0,1,9,3H6.439l5.906,5.926a.22.22,0,0,0,.157.065h0a.218.218,0,0,0,.156-.064l6.884-6.884a1,1,0,0,1,1.414,1.414l-6.884,6.884a2.2,2.2,0,0,1-1.57.65h0a2.206,2.206,0,0,1-1.572-.653L5,4.389V7A1,1,0,0,1,3,7ZM24,20.107l-.085,1.264A2.707,2.707,0,0,1,21.2,24.022c-.044,0-2.522-.322-2.522-.322a2.726,2.726,0,0,1-2.649-2.654l-.155-1.292A11.11,11.11,0,0,0,12,19a10.68,10.68,0,0,0-3.863.744l-.157,1.3A2.726,2.726,0,0,1,5.326,23.7s-2.478.322-2.522.322A2.724,2.724,0,0,1,.083,21.3L0,20.176A5.249,5.249,0,0,1,1.556,16.4c4.491-4.488,16.4-4.487,20.887,0A5.216,5.216,0,0,1,24,20.107Zm-2-.07a3.2,3.2,0,0,0-.974-2.22c-3.982-3.985-14.627-3.429-18.057,0A3.225,3.225,0,0,0,2,20.105l.081,1.127a.747.747,0,0,0,.671.789s2.458-.32,2.5-.32a.724.724,0,0,0,.722-.722c0-.04.239-2.05.239-2.05a1,1,0,0,1,.585-.794A12.532,12.532,0,0,1,11.942,17h.063a13.354,13.354,0,0,1,5.18,1.128,1,1,0,0,1,.6.8s.239,2.01.239,2.05a.724.724,0,0,0,.722.722c.044,0,2.5.32,2.5.32a.722.722,0,0,0,.669-.719Z"
    />
  </svg>
  <svg
    v-else-if="props.type == 'Courrier RAR'"
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="512"
    height="512"
    fill="rgba(109, 32, 119, 1)"
  >
    <path
      d="M24,16.5v2A5.506,5.506,0,0,1,18.5,24H5.5A5.506,5.506,0,0,1,0,18.5V8.5A5.506,5.506,0,0,1,5.5,3h6a1.5,1.5,0,0,1,0,3h-6A2.493,2.493,0,0,0,3.3,7.336l6.931,6.932a2.555,2.555,0,0,0,3.017.4,1.5,1.5,0,1,1,1.5,2.6,5.523,5.523,0,0,1-6.64-.874L3,11.278V18.5A2.5,2.5,0,0,0,5.5,21h13A2.5,2.5,0,0,0,21,18.5v-2A1.5,1.5,0,0,1,24,16.5ZM22,0H17a2,2,0,0,0-2,2v9.654a1.35,1.35,0,0,0,2.193,1.054L19.5,10.863l2.307,1.845A1.35,1.35,0,0,0,24,11.654V2A2,2,0,0,0,22,0Z"
    />
  </svg>
  <svg
    v-else-if="props.type == 'Courrier Simple'"
    xmlns="http://www.w3.org/2000/svg"
    id="Bold"
    viewBox="0 0 24 24"
    width="512"
    height="512"
    fill="rgba(109, 32, 119, 1)"
  >
    <path
      d="M18.5,1H5.5A5.506,5.506,0,0,0,0,6.5v11A5.506,5.506,0,0,0,5.5,23h13A5.506,5.506,0,0,0,24,17.5V6.5A5.506,5.506,0,0,0,18.5,1Zm0,3a2.476,2.476,0,0,1,1.643.631l-6.5,6.5a2.373,2.373,0,0,1-3.278,0l-6.5-6.5A2.476,2.476,0,0,1,5.5,4Zm0,16H5.5A2.5,2.5,0,0,1,3,17.5V8.017l5.239,5.239a5.317,5.317,0,0,0,7.521,0L21,8.017V17.5A2.5,2.5,0,0,1,18.5,20Z"
    />
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="512"
    height="512"
    fill="rgba(109, 32, 119, 1)"
  >
    <path
      d="M12,24c-1.431,0-2.783-.551-3.807-1.552l-3.943-3.643c-2.106-2.105-3.25-4.867-3.25-7.805s1.144-5.701,3.222-7.778C6.299,1.145,9.062,0,12,0s5.7,1.145,7.778,3.222c2.078,2.077,3.222,4.839,3.222,7.778s-1.145,5.7-3.222,7.778l-3.992,3.689c-1.003,.981-2.355,1.533-3.787,1.533Zm0-22c-2.404,0-4.665,.936-6.364,2.636-1.7,1.7-2.636,3.959-2.636,6.364s.936,4.664,2.636,6.364l3.935,3.635c1.336,1.306,3.543,1.286,4.837,.02l3.984-3.682c1.671-1.673,2.608-3.933,2.608-6.336s-.937-4.664-2.636-6.364h0c-1.7-1.7-3.96-2.636-6.364-2.636Zm4.707,11.05c.391-.391,.391-1.023,0-1.414s-1.023-.391-1.414,0c-.879,.879-2.049,1.364-3.293,1.364s-2.414-.484-3.293-1.364c-.391-.391-1.023-.391-1.414,0s-.391,1.023,0,1.414c1.257,1.257,2.929,1.95,4.707,1.95s3.45-.692,4.707-1.95Zm-7.207-6.05c-.828,0-1.5,.672-1.5,1.5s.672,1.5,1.5,1.5,1.5-.672,1.5-1.5-.672-1.5-1.5-1.5Zm5,0c-.828,0-1.5,.672-1.5,1.5s.672,1.5,1.5,1.5,1.5-.672,1.5-1.5-.672-1.5-1.5-1.5Z"
    />
  </svg>
</template>
